import React,{useState} from 'react'
import Top_heading from './component/Top_heading'
import ContactArea from './services-component/ContactArea'
import Component_Heading from './component/Component_Heading';

export default function ContactUs() {
  const [Maptabbs , setMaptabbs]=useState(1);

  function tabschanger(id){
    setMaptabbs(id)
  }
  const MapComponentIndia = () => {
    return (
      <div className="MapAreaStyle" style={{ width: '100%', height: '450px' }}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2753.6844486422633!2d73.87617697344243!3d18.518175169250856!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c04fbd1ddb6b%3A0xa6f1f9f58491c772!2sAurora%20Towers%2C%20Camp%2C%20Pune%2C%20Maharashtra%20411001!5e1!3m2!1sen!2sin!4v1770293787948!5m2!1sen!2sin"
          width="600"
          height="450"
          style={{ border: '0' }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    );
  };
  const MapComponentDubai = () => {
    return (
      <div className="MapAreaStyle" style={{ width: '100%', height: '450px' }}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d460074.0851262918!2d55.638593960689334!3d25.726638443993554!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef676ad264b24c1%3A0x10f6affe1a9e78a3!2sRas%20Al-Khaimah%20-%20Ras%20Al%20Khaimah%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2sin!4v1726213353351!5m2!1sen!2sin"
          width="600"
          height="450"
          style={{ border: '0' }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    );
  };
  return (
    <>
      <Top_heading Heading="CONTACT US"/>
      
     
      <div className="additional-div">

      </div>
      <Component_Heading heading="CONTACT HERE"
para="We’re here to help you grow. Whether you have a project in mind, need expert advice, or simply want to explore how digital marketing can elevate your brand, we’d love to hear from you. Our team is ready to assist with tailored solutions that match your business goals. Reach out today and let’s start building something impactful together. Your success is just a message away."/>
      <div className="map-tab-button">
          <button onClick={()=>tabschanger(1)} className={ Maptabbs===1 ? "tabs1" : "tabs2"}>Dubai</button>
          <button onClick={()=>tabschanger(2)} className={ Maptabbs===2 ? "tabs1" : "tabs2"}>India</button>

      </div>
      
     
   
   <div className={ Maptabbs===2 ? "showtabs1" : "hidetabs"}>
   {MapComponentIndia()}
    </div>
    <div className={ Maptabbs===1 ? "showtabs1" : "hidetabs"}>
    {MapComponentDubai()}
    </div>
    
    <ContactArea/>
    <div className="blueStrip">
      </div>
    </>
    
  )
}

